import React from "react";

/**
 * City AI Studio brand mark.
 * Small filled circle (deep navy) with an inner blue dot — same family
 * as the reference, but distinctively ours. Wordmark uses Outfit.
 */
export const BrandMark = ({ size = 36 }) => (
  <span className="inline-flex items-center justify-center" aria-hidden>
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <radialGradient id="cm-grad" cx="35%" cy="30%" r="80%">
          <stop offset="0%" stopColor="#60A5FA" />
          <stop offset="55%" stopColor="#1D4ED8" />
          <stop offset="100%" stopColor="#0B1A4A" />
        </radialGradient>
      </defs>
      <circle cx="20" cy="20" r="18" fill="url(#cm-grad)" />
      <circle cx="14" cy="14" r="3.4" fill="#FFFFFF" opacity="0.95" />
      <circle cx="14" cy="14" r="1.4" fill="#1D4ED8" />
    </svg>
  </span>
);

export const Wordmark = ({ className = "" }) => (
  <a
    href="#top"
    data-testid="brand-wordmark"
    className={`inline-flex items-center gap-3 group ${className}`}
  >
    <BrandMark size={26} />
    <span className="wordmark text-[18px] text-ink-50 leading-none">
      City <span className="text-brand">AI</span> Studio
    </span>
  </a>
);

export default Wordmark;
